import React, { useState } from 'react';
import { useTimer } from 'react-timer-hook';
import { DisplayText, Spinner } from '@superops/ui-design-system';
import { CircleProgress } from 'react-gradient-progress';

function TotpTimer({
  expiryTime,
  refetchTotpFieldValue,
  setViewing
}: {
  expiryTime: number;
  refetchTotpFieldValue: any;
  viewing: boolean;
  setViewing: (viewing: boolean) => void;
}) {
  const MAX_REFETCH = 5;
  const [isLoading, setIsLoading] = useState(false);
  const [refetchCount, setRefetchCount] = useState(1);
  const createExpiry = (expiryTimeInSeconds: number = expiryTime) => {
    return new Date(Date.now() + expiryTimeInSeconds * 1000);
  };
  const fetchNewTotp = async () => {
    console.log('Calling API for new TOTP...');
    setIsLoading(true);
    try {
      const res = await refetchTotpFieldValue();
      restart(createExpiry(res?.data?.getTotpFieldValue?.expiryTimeInSeconds));
      setViewing(true);
    } catch (err) {
      console.log('err', err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const { seconds, restart } = useTimer({
    expiryTimestamp: createExpiry(),
    onExpire: async () => {
      if (refetchCount < MAX_REFETCH) {
        await fetchNewTotp();
        setRefetchCount((prev) => prev + 1);
      } else {
        setViewing(false);
      }
    }
  });

  return (
    <>
      {isLoading ? (
        <Spinner size="small" />
      ) : (
        <div className="position-relative flex jctr">
          <CircleProgress
            percentage={Math.max(
              0,
              Math.min(100, Math.round((seconds / 30) * 100))
            )}
            width={38}
            strokeWidth={3}
            primaryColor={['#10B981', '#10B981']}
            secondaryColor="#EDEDED"
            fontColor="transparent"
          />
          <div className="position-absolute flex actr jctr t0 l0 b0 r0">
            <DisplayText element="div">{seconds}</DisplayText>
          </div>
        </div>
      )}
    </>
  );
}

export default TotpTimer;
